import React from 'react';
import ReactDOM from 'react-dom';
import * as Sentry from '@sentry/react';
import { LDClient, LDProvider } from 'providers/launch-darkly';
import { App } from './app';
import '@perch-labs/shrike/dist/shrike.css';

const env = import.meta.env.MODE;

if (['production', 'staging'].includes(env)) {
  Sentry.init({
    dsn: import.meta.env.ARCADIA_SENTRY_DSN,
    environment: env,
    ignoreErrors: ['Non-Error promise rejection captured with value:'],
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampler: samplingContext => {
      if (
        env === 'production' &&
        samplingContext.transactionContext.op === 'pageload'
      ) {
        return 0.75;
      } else {
        return 0;
      }
    },
  });
}

if (env !== 'production') {
  // shows everywhere but production - remove this if block once Spanish goes live
  window.Localize.showWidget();
}

ReactDOM.render(
  <LDProvider client={LDClient}>
    <App />
  </LDProvider>,
  document.getElementById('root')
);
